// extracted by mini-css-extract-plugin
export default {"container":"QRcode_container__REyNm","botButton":"QRcode_botButton__iQLyH","backLink":"QRcode_backLink__hoz2H"};